<template>
  <v-app>
    <v-main>
      <router-view class="appBar" name="appBar"/>
      <router-view class="sideBar" name="sideBar"/>
      <router-view class="sideBarRight" name="sideBarRight"/>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  data: () => ({
    //
  }),
};
</script>

<style>
  /* @font-face {
    font-family: 'Montserrat';
    src: local('Montserrat'), url('./assets/fonts/Montserrat/static/Montserrat-Light.ttf')  format('truetype');
    font-style: normal;
  } */
  /* @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed'); */
  @import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@450&display=swap");
  .v-application,.body {
    font-family: "Montserrat", sans-serif !important;
  }

  .bg-steii {
    background-color: #A88E68;
  }
  .text-steii {
    color: #A88E68,
  }
  .w-100 {
    width: 100% !important;
  }
  .v-input__slot:before {
    border: none !important;
  }
  .v-data-table__wrapper > table > thead > tr:last-child > th {
    border-bottom: none !important;
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
    border-bottom: none !important;
  }
  .theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr {
    box-shadow: 0px 3px 16px #0000001F;
    border-radius: 12px;
  }
  .v-data-table__wrapper {
    overflow-x: visible !important;
    overflow-y: visible !important;
  }
  .v-data-table__wrapper > table {
    border-collapse: separate !important;
    border-spacing: 0 .6rem !important;
  }
  .theme--light.v-data-table .v-data-footer {
    border-top: none !important;
  }
  .v-data-table__mobile-table-row {
    margin-bottom: 10px;
  }
</style>
